module.exports = __webpack_public_path__ + "static/media/shape0_3.0a647cbe.obj";